import DOMPurify from "dompurify";

function SanitizedHtml({html}:{html: string | undefined}) {
    const safeHtml = html ? DOMPurify.sanitize(html) : '';

    return (
        <div dangerouslySetInnerHTML={{__html: safeHtml}}></div>
    )
}


export default SanitizedHtml;